/* eslint-disable jsx-a11y/anchor-is-valid */
import { NavDropdown, Nav, Spinner, ToastContainer, Toast } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import {
    clickStreamUser,
    SessionKeys,
    logoutClearSession,
    applyTheme,
    IsLogin,
    getStepIndex,
    getJoyRideScript,
    randomGenerator,
    isMainDomain,
    getCurrentLocationPath,
} from "../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import {
    loginClear,
    logout,
    logoutBroker,
    loginBrokerClear,
    logoutBrokerClear,
    logoutClear,
    loginHostInstClear,
} from "../redux/auth/actions";
import { getSelectedCatId, openHamburgerClear } from "../redux/courses/actions";
import { useEffect, useRef, useState } from "react";
import _ from "lodash";
import ProfileMenuSection from "./ProfileMenuSection";
import CategoryMenuNIIT from "./LearningMenu/CategoryMenuNIIT";
import CategoryMenuProduct from "./LearningMenu/CategoryMenuProduct";
import CategoryMenuBroker from "./LearningMenu/CategoryMenuBroker";
import { setUserPremium } from "../redux/user/actions";
import CONFIG from "../utils/config";
import $ from "jquery";
import { getAllCertifiedNIIT } from "../redux/certified/actions";
// import {
//   notificationResponse,
//   notificationData,
//   notificationClear,
// } from "../redux/notification/actions";
import Notification from "./Notification";
import Loader from "./Loader/Loader";
import LiveButtonComponent from "./Layouts/LiveButton/LiveButtonComponent";
import { getActiveHeader, getLoginLogo, getLoginLogoClear, getShowLoader, getSmartBar, homePageMsgClear, homePageShowMsg, setLiveBlink } from "../redux/home/actions";
import MsgModal from "./modal/MsgModal";
import Joyride, { ACTIONS, CallBackProps, STATUS, Step } from 'react-joyride';
import { setJoyRideReq, setShowDropDown, setShowMoreMenuReq } from "../redux/assignCourse/actions";
import { updateTourAndGuideComplete } from "../redux/reports/actions";
import { useAuth } from "../utils/auth";
import LiveMenuComponent from "./Layouts/LiveButton/LiveMenuComponent";
import CalendarLogicComponent from "./Layouts/LiveButton/CalendarLogicComponent";
import useLogin from "../custom-hooks/useLogin";
import FormButtonComponent from "./NewDesign/FormControl/FormButton/FormButtonComponent";
import "./header.scss";
import { routeList } from "../utils/routeList";
import { addToWishListClear } from "../redux/product/actions";
import { getLiveSessionList } from "../redux/events/actions";
import ChatBotComponent from "./ChatBot/ChatBotComponent";
import API_LIST from "../utils/apiList";

const HeaderNewMenu = ({ showMenu }) => {
    const coursesListingData = useSelector((state) => {
        return state.courses.coursesListing;
    });
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const hamburgerMenu = useRef();
    const { isLoggedIn, userData, loginData } = useLogin();

    const auth = useSelector((state) => state.auth);
    const isLogout = useSelector((state) => state.auth.isLogout);
    const authBroker = useSelector(state => state.auth.authBroker)
    const authLogoutBroker = useSelector((state) => state.auth.authLogoutBroker);
    const openHamburger = useSelector((state) => state.courses.openHamburger);
    const certifiedData = useSelector((state) => state.certified.allCertified);
    const userRole = useSelector((state) => state.user.role);
    const sessionCount = useSelector((state) => state.user.sessionCount);
    const userDetailRes = useSelector(state => state.user.userBroker)
    const showHomePageMsg = useSelector(state => state.home.showHomePageMsg)
    const homePageMsg = useSelector(state => state.home.homePageMsg)
    const joyRideRes = useSelector((state) => state.assignCourse.joyRideRes);
    const isPremiumUser = useSelector(state => state.user.isPremiumUser);
    const tourAndGuideRes = useSelector((state) => state.report?.tourAndGuideRes);
    const liveSessionsResponse = useSelector(
        (state) => state.events.liveSessionsData
      );

    const showMoreMenuRes = useSelector((state) => state.assignCourse.showMoreMenuRes);
    const myCartRes = useSelector(state => state.carts.myCart)
    const addToCartRes = useSelector((state) => state.product.addToCart);


    //console.log("User roles", userRole);
    const [menuConfig, setMenuConfig] = useState({})
    const [show, setShow] = useState(false);
    const [showMobMenu, setShowMobMenu] = useState(false);
    const [showAllMenu, setShowAllMenu] = useState(true);
    const [logo, setLogo] = useState("");
    const [isGuest, setIsGuest] = useState(false);
    const [cartCount, setCartCount] = useState(0);
    const [isCartLoading, setIsCartLoading] = useState(false)
    const [certifiedList, setCertifiedList] = useState([]);
    const [otherRole, setOtherRole] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [name, setName] = useState('')
    const [confirmMsgModal, setConfirmMsgModal] = useState(false)
    const [showModalMsg, setShowModalMsg] = useState('')
    const [activeMenu, setActiveMenu] = useState('')
    const [showMoreMenu, setShowMoreMenu] = useState(false)
    const [showCertMenu, setShowCertMenu] = useState(false)
    const [joyState, setJoyState] = useState({
        run: false
    });
    const [showHeaderMenu, setShowHeaderMenu] = useState({
        subscription: true
    })
    const [moreMenu,] = useState([
        { value: 'report', label: 'Reports', main: true },
        { value: 'toolbox', label: 'My Toolbox', main: true },
        { value: 'role-request', label: 'My Network', main: true },
        { value: '', label: 'My Learning', main: true },
        { value: 'my-onboarding', label: '- Onboarding', main: false },
        { value: 'learning-path', label: '- Learning Path', main: false },
        { value: 'courses', label: '- Courses', main: false },
        { value: 'videos', label: '- Videos', main: false },
        { value: 'events', label: '- Events', main: false },
        { value: 'my-certificates', label: '- Certificates', main: false },
        { value: 'my-badges', label: '- Badges', main: false },
        { value: 'learning-points', label: '- Learning Points', main: false },
        // { value: 'other-services', label: '- Other Services', main: false },
    ])
    const loginLogo = useSelector((state) => state.home.loginLogo);
    const authProvider = useAuth();
    const activeHeaderItem = useSelector((state) => state.home.activeHeader);
    useEffect(() => {
        
       console.log("active--",activeHeaderItem)
    }, [activeHeaderItem]);

    useEffect(() => {
        IsLogin();
        localStorage.setItem('sessionId', randomGenerator())
        setTimeout(() => {
            dispatch(
                getLiveSessionList({
                  module: "getLiveSessions",
                  postData: {
                    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER) : "",
                  },
                })
            );
            dispatch(
                getSmartBar({
                  module: "getSmartBar",
                  postData: {
                    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER) : "",
                  },
                })) 
        }, 2000)

        if(!isMainDomain() && !isLoggedIn){
            const domainArray = window.location.host.split('.');
            const subDomain = domainArray[0];
            dispatch(
                    getLoginLogo({
                      URL: `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.BROKER_API.LOGIN_LOGO_URL}`,
                      payload: {
                        company_ref: subDomain,
                        // email: localStorage.getItem('redirect_email')
                      },
                      isJSON: true,
                      method: "post",
                    })
                  );
        }
    }, [dispatch])

    useEffect(() => {
        if (!_.isEmpty(loginLogo) && !isMainDomain() && !isLoggedIn) {
          if (
            loginLogo.status === "success" &&
            !_.isEmpty(loginLogo.payload?.data)
          ) {
            if (loginLogo.payload.data.company_logo) {
              setLogo(loginLogo.payload.data.company_logo);
            } else {
              setLogo("")
            }
            dispatch(getLoginLogoClear());
          }
          dispatch(getLoginLogoClear());
        }
      }, [loginLogo]);

    useEffect(() => {
        if (document.getElementById("id_page_404") !== null) {
            document.getElementById("id_page_404").style.display = "none";
        }
    }, [])

    useEffect(() => {
        if (!_.isEmpty(liveSessionsResponse)) {
            if (liveSessionsResponse.status == 'success') {
                // alert(JSON.stringify(liveSessionsResponse.payload.payload))
                if (!_.isEmpty(liveSessionsResponse.payload?.payload)) {
                    dispatch(setLiveBlink(true))
                } else {
                    dispatch(setLiveBlink(false))
                }
            } else {
                dispatch(setLiveBlink(false))
            }
        }
    }, [liveSessionsResponse])

    

    useEffect(()=>{
       
                if(window.location.pathname.includes("our-partners")){
                    dispatch(getActiveHeader("our-partners"))
                }
                if((window.location.pathname.includes("learn") || window.location.pathname.includes("event-detail")) && !window.location.pathname.includes("learningpath")){
                    dispatch(getActiveHeader("learn"))
                }
                if(window.location.pathname.includes("live-events")){
                    dispatch(getActiveHeader("live-events"))
                }
                if(window.location.pathname.includes("events-calendar")){
                    dispatch(getActiveHeader("events-calendar"))
                }
                if(window.location.pathname.includes("/learn/learningpath") || window.location.pathname.includes("/moduleDetail") || window.location.pathname.includes("/video-view-page")) {
                    dispatch(getActiveHeader("learn"))
                }

    },[window.location.pathname])

    useEffect(() => {
        if (window.location.pathname) {
            console.log("tab", fetchActiveMenu(window.location.pathname), window.location.pathname,activeHeaderItem)
            setActiveMenu(fetchActiveMenu(window.location.pathname))
        }
    }, [window.location.pathname, activeHeaderItem])

    useEffect(() => {
        if (!_.isEmpty(myCartRes)) {
            setIsCartLoading(false)
            console.log('myCartRes >', myCartRes)
            if (myCartRes?.cart_list?.length > 0)
                setCartCount(myCartRes?.cart_list?.length)
            else setCartCount(0)

        } else {
            // setCartCount(0)

        }
    }, [myCartRes])

    useEffect(() => {
        if (!_.isEmpty(addToCartRes)) {
            setIsCartLoading(true)
        }
    }, [addToCartRes])

    const showDropdown = (e) => {
        //console.log("hide");
        setShow(!show);
    };
    const hideDropdown = (e) => {
        //console.log("show");
        setShow(false);
    };
    const [courseCategories, setCourseCategories] = useState([]);

    useEffect(() => {
        if (!_.isEmpty(authBroker)) {
            setName(`${authBroker.payload.user.firstname}`)
            setIsGuest(authBroker.payload.user.role.includes('guest'))
            if (!_.isEmpty(authBroker.payload.user.role)) {
                setMenuConfig(authBroker.payload.user.config)
            } else {
                setMenuConfig({})
            }
            if((userRole != "customer") && !authBroker.payload.user.display_subscription_menu && localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
                let showSub = _.cloneDeep(showHeaderMenu);
                showSub.subscription = false;
                setShowHeaderMenu(showSub)
            }
        }
    }, [authBroker, userRole])

    useEffect(() => {
        if (_.isBoolean(showMoreMenuRes)) {
            setShowMoreMenu(showMoreMenuRes)
        }
    }, [showMoreMenuRes])

    useEffect(() => {
        // console.log(
        //   "privacy-temrms ",
        //   localStorage.getItem(SessionKeys.IS_AGGREED) === "undefined"
        // );
        if (
            localStorage.getItem(SessionKeys.IS_AGGREED) === undefined ||
            localStorage.getItem(SessionKeys.IS_AGGREED) === "undefined" ||
            localStorage.getItem(SessionKeys.IS_AGGREED) === "false"
        ) {
            navigate("/privacy-and-terms");
        }
    }, [dispatch, navigate]);

    const signOut = () => {
        setIsLoading(true)
        dispatch(
            logoutBroker({
                module: "userlogout",
                postData: {
                    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                },
            })
        );
    };

    useEffect(() => {
        if (showMenu) {
            // dispatch(
            //     getAllCertifiedNIIT({
            //         module: "getAllCertifiedList",
            //         postData: {
            //             module: "AllCertificate",
            //         },
            //     })
            // );
        }
    }, [dispatch, userRole]);

    useEffect(() => {
        //console.log("LOGOUT IS CALLED", authLogoutBroker);
        if (!_.isEmpty(authLogoutBroker)) {
            window.captureMyEvents("logout", {
                userId: auth?.authBroker?.payload.user.user_id,
                message: "User logged out",
            });
            let email = null,
                pass = null;
            if (localStorage.getItem(SessionKeys.IS_REMEMBERED)) {
                email = localStorage.getItem(SessionKeys.EMAIL);
                pass = localStorage.getItem(SessionKeys.PASS);
            }
            // alert('Logout button clicked',authLogoutBroker)
            localStorage.clear();

            if (email !== null) {
                localStorage.setItem(SessionKeys.IS_REMEMBERED, true);
                localStorage.setItem(SessionKeys.EMAIL, email);
                localStorage.setItem(SessionKeys.PASS, pass);
            }

            $("html").css("--color-element-1", CONFIG.COLOR_ELEMENT_1);
            $("html").css("--color-element-2", CONFIG.COLOR_ELEMENT_2);
            if (authBroker.payload.user.apply_theme) {
                if ($('body').hasClass('cus-bro-theme')) {
                    $('body').removeClass('cus-bro-theme')
                }
            }
            dispatch(logoutClear());
            dispatch(loginClear());
            // dispatch(setUserPremium(false))
            logoutClearSession();

            dispatch(loginBrokerClear());
            dispatch(logoutBrokerClear());
            setIsLoading(false)
            authProvider.logout();
            navigate("/", { logout: true });
            window.location.reload(false);
        }
    }, [authLogoutBroker]);

    useEffect(() => {
        if (!_.isEmpty(auth.authBroker)) {
            setOtherRole(auth.authBroker.payload.user.role);
            setLogo(auth.authBroker.payload.user.branding_company_logo);
            let colorElement1 =
                auth.authBroker.payload.user.branding_primary_color_1;
            let colorElement2 =
                auth.authBroker.payload.user.branding_primary_color_2;
            if (!colorElement1?.includes('#')) {
                colorElement1 = '#' + colorElement1;
            }
            if (!colorElement2?.includes('#')) {
                colorElement2 = '#' + colorElement2;
            }
            $("html").css("--color-element-1", colorElement1);
            $("html").css("--color-element-2", colorElement2);
            if (auth.authBroker.payload.user.apply_theme) {
                if (!$('body').hasClass('cus-bro-theme')) {
                    $('body').addClass('cus-bro-theme')
                }
                const branding = auth.authBroker.payload.user.branding
                !_.isEmpty(branding) && applyTheme(branding)
            } else {
                if ($('body').hasClass('cus-bro-theme')) {
                    $('body').removeClass('cus-bro-theme')
                }
            }
        }
    }, [auth]);

    useEffect(() => {
        setShowAllMenu(showMenu);
    }, [showMenu]);

    useEffect(() => {
        if (isLogout) {
            //console.log(isLogout);
            // navigate("/", { logout: true });
        }
    }, [isLogout]);

    useEffect(() => {
        //console.log("openHamburger", openHamburger);
        if (openHamburger) {
            // console.log(hamburgerMenu);
            // var btnEl = document.querySelector("#mySidenav");
            // if (!btnEl.classList.contains("open")) {
            //   hamburgerMenu.current.click();
            // }
            var btnEl = document.querySelector("#forHandleBurgerMenu");
            if (!btnEl.classList.contains("closeopen")) {
                hamburgerMenu.current.click();
            }
            dispatch(openHamburgerClear(false));
        }
    }, [openHamburger]);

    useEffect(() => {
        //console.log("token", SessionKeys.API_TOKEN_BROKER);
        if (Object.entries(auth.authBroker).length > 0) {
            const authData = auth.authBroker;
            //  console.log("authData", authData);
            if (!authData.payload.apiToken) {
                localStorage.removeItem(SessionKeys.API_TOKEN_BROKER);
                localStorage.removeItem(SessionKeys.NOTI_SHOW);
                // dispatch(loginClear());
                // navigate("/", { relogin: true });
            }
        }
        // else if (!localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
        // dispatch(loginClear());
        // navigate("/", { relogin: true });
        // }
    }, [auth]);

    useEffect(() => {
        // console.log("CertifiedData", certifiedData);
        if (!_.isEmpty(certifiedData) && certifiedData.status === "success") {
            if (!_.isEmpty(certifiedData.payload.payload)) {
                let certifiedArray = certifiedData.payload.payload;
                for (let certify of certifiedArray) {
                    certify.source = "xsel";
                }
                setCertifiedList(certifiedArray);
            }
        }
    }, [certifiedData]);

    const goToCertifiedDetail = (item) => {
        clickStreamUser("go-to-certified-detail", {
            certifyId: item.wp_id,
            certifyCode: item.c_code,
            source: item.source,
            userId: auth.authBroker?.payload.user.user_id,
        });
        navigate(
            `/certify-detail?certify_id=${item?.wp_id}&certify_code=${item?.c_code}&source=${item.source}`
        );
    };

    const goToMoreMenu = (menuName) => {
        switch (menuName) {
            case 'learning-path':
                navigate('/learning-paths');
                clickStreamUser('learning_menu_clicked', {
                    "categoryName": "Learning Paths",
                    "userId": auth.authBroker?.payload?.user.user_id,
                })
                break;
            case 'my-onboarding':
                navigate('/my-onboarding');
                clickStreamUser('my_onboarding_menu_clicked', {
                    "userId": auth.authBroker?.payload?.user.user_id,
                })
                break;
            case 'report':
                navigate('/report');
                clickStreamUser('report_menu_clicked', {
                    "userId": auth.authBroker?.payload?.user.user_id,
                })
                break;
            case 'toolbox':
                navigate('/toolbox?folderId=0');
                clickStreamUser('my-toolbox-clicked', {
                    "categoryName": "My Toolbox",
                    "userId": auth.authBroker?.payload?.user.user_id,
                })
                break;
            case 'role-request':
                navigate('/accept-role')
                clickStreamUser('role_requests_menu_click', {
                    userId: auth.authBroker?.payload?.user.user_id
                })
                break;
            case 'my-certificates':
                navigate(`/profile/edit?section=edit&tab=6&user_id=${localStorage.getItem(SessionKeys.USER_ID)}`)
                clickStreamUser('my-certificates_menu_click', {
                    userId: auth.authBroker?.payload?.user.user_id
                })

                break;
            case 'my-badges':
                navigate(`/profile/edit?section=edit&tab=7&user_id=${localStorage.getItem(SessionKeys.USER_ID)}`)
                clickStreamUser('my-certificates_menu_click', {
                    userId: auth.authBroker?.payload?.user.user_id
                })
                break;
            case 'learning-points':
                navigate('/learning-points')
                clickStreamUser('learning-points_menu_click', {
                    userId: auth.authBroker?.payload?.user.user_id
                })
                break;
            case 'videos':
                navigate('/my-videos')
                clickStreamUser('my-videos-menu-click', {
                    userId: auth.authBroker?.payload?.user.user_id
                })
                break;
            case 'events':
                navigate('/my-events')
                clickStreamUser('my-events-menu-click', {
                    userId: auth.authBroker?.payload?.user.user_id
                })
                break;
            case 'courses':
                navigate('/my-courses');
                clickStreamUser('my_courses_menu_clicked', {
                    "categoryName": "Courses",
                    "userId": auth.authBroker?.payload?.user.user_id,
                })
                break;
            // case 'other-services': 
            //     navigate('/other-services');
            default:
                break;
        }
    }

    const toggleNav = () => {
        var btnEl = document.querySelector("#mySidenav");
        var main = document.querySelector(".main");
        var toogleicons = document.querySelector(".closetoogle");
        // console.log(btnClasslist)
        if (btnEl.classList.contains("open")) {
            //document.getElementById("openbtn").innerHTML = "<span></span><span></span><span></span>";
            document.getElementById("openbtn").classList.add("mystyle");
            toogleicons.classList.remove("closeopen");
            btnEl.classList.remove("open");
            main.style.marginLeft = "0px";
        } else {
            //document.getElementById("openbtn").innerHTML ="<span class='closetoogle'></span><span class='closetoogle'></span>";
            document.getElementById("openbtn").classList.remove("mystyle");
            btnEl.classList.add("open");
            toogleicons.classList.add("closeopen");
            main.style.marginLeft = "0px";
        }
    };
    // const toggleNavDesktop = () => {
    //     var bodyclass = document.querySelector("body");
    //     var btnEl = document.querySelector("#mySidenav");
    //     var main = document.querySelector(".main");
    //     var smartbar = document.querySelector(".smart-bar");
    //     var toogleicon = document.querySelector("#openbtnd .closetoogle");
    //     var footerSlide = document.querySelector(".footersection");
    //     console.log(btnClasslist)
    //     if (btnEl.classList.contains("open")) {
    //         //document.getElementById("openbtnd").innerHTML = "<span class='closetoogle'></span>";
    //         btnEl.classList.remove("open");
    //         toogleicon.classList.add("closeopen");
    //         main.style.marginLeft = "26.25rem";
    //         bodyclass.classList.remove("sidemenuopened");
    //         smartbar.style.marginLeft = "26.25rem";
    //         footerSlide.classList.add("showfot")
    //     } else {
    //         //document.getElementById("openbtnd").innerHTML ="<span class='opentogglbar'></span>";
    //         btnEl.classList.add("open");
    //         toogleicon.classList.remove("closeopen");
    //         main.style.marginLeft = "0";
    //         bodyclass.classList.add("sidemenuopened");
    //         smartbar.style.marginLeft = "0";
    //         footerSlide.classList.remove("showfot")

    //     }
    // };
    const goToVideo = () => {
        clickStreamUser("video_menu_clicked", {
            userId: auth?.authBroker?.payload?.user.user_id,
        });
        navigate("/video-categories");
    };

    const goToRolePlay = (type) => {
        if (type === "review-role-play") {
            clickStreamUser("review-role-play", {
                userId: auth?.authBroker?.payload?.user.user_id,
            });
            navigate("/review-role-play");
        } else if (type === "my-role-plays") {
            clickStreamUser("my-role-plays", {
                userId: auth?.authBroker?.payload?.user.user_id,
            });
            navigate("/my-role-plays");
        } else if (type === "role-play") {
            clickStreamUser("role-play", {
                userId: auth?.authBroker?.payload?.user.user_id,
            });
            navigate("/role-play");
        }
    };
    // const isXselProvided = () => {
    //     return location.search.includes("?source=xsel");
    //     if (source === 'xsel' || source === 'ecom') {
    //         return true
    //     } else return false
    // }

    useEffect(() => {
        if (showHomePageMsg && homePageMsg) {
            window.scrollTo(0, 0)
            setConfirmMsgModal(true)
            setShowModalMsg(homePageMsg)
            setTimeout(() => {
                dispatch(homePageShowMsg(false))
                dispatch(homePageMsgClear(''))
                setConfirmMsgModal(false)
                setShowModalMsg('')
            }, 10000)
        }
    }, [showHomePageMsg, homePageMsg])


    const renderCard = () => {
        return (

            <MsgModal
                confirmModal={confirmMsgModal}
                setConfirmModal={setConfirmMsgModal}
                showModalMsg={showModalMsg}
                isConfirm={false}
                confirmId={""}
                confirmAction={function name(params) {
                }} />
        )
    }

    const [scroll, setScroll] = useState(false)
    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 55)
        })
    }, [])

    const navigateToDetails = () => {
        navigate(routeList.CART_PAGE)
    }

    const fetchActiveMenu = (pathname) => {
        console.log(pathname.includes('learn'))
        // alert(pathname);
        // if (pathname.includes('learn') || pathname.includes("moduleDetail") || 
        //   pathname.includes("video-view-page") || pathname.includes("courseDetail") || pathname.includes("lpDetail") ||
        // pathname.includes("event-detail") || pathname.includes("coaching-detail") || pathname.includes("bundleDetail")) {
        //     return 'learn';
        // } else 

        switch(activeHeaderItem)
        {
            case "home":
                return 'home';
            case "our-partners":
                return 'our-partners';
            case "learn":
                return 'learn';
            case "event-detail":
                return 'learn';
            case "subscription":
                return 'subscriptions';
            case 'live-events':
                return 'live-events'
            case "events-calendar":
                return "events-calendar";  
            case "event-detail":
                return 'learn';
            default:
                return '';
        }
//         if (pathname.includes('learn') || 
//       pathname.includes("moduleDetail") || 
//       pathname.includes("video-view-page") || 
//       pathname.includes("courseDetail") || 
//       pathname.includes("lpDetail") || 
//       pathname.includes("event-detail") || 
//       pathname.includes("coaching-detail") || 
//       pathname.includes("bundleDetail")) {
//     return 'learn';
//   } else if (pathname.includes("our-partners")) {
//     return 'our-partners';
//   } else if (pathname.includes("live-events")) {
//     return 'live-events';
//   } else if (pathname.includes("events-calendar")) {
//     return 'events-calendar';
//   } else if(pathname.includes("home") || pathname === "/") {
//     return 'home';
//   } else {
//     return ''
//   }

       
    }

    useEffect(() => {

        if (!_.isEmpty(tourAndGuideRes)) {
            if (tourAndGuideRes?.status === "success") {
                sessionStorage.setItem(SessionKeys.COMPLETE_TOUR, "1")
            }
        }

    }, [tourAndGuideRes])

    const handleJoyrideCallback = (data) => {
        console.log(data)
        const { status, type, action, index, lifecycle, step } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (action === "skip" || type === "tour:end") {
            dispatch(setJoyRideReq({ run: false, stepIndex: 0 }))
            sessionStorage.setItem(SessionKeys.IS_TOUR, "NO")
            if (document.getElementById("idForTour") !== null) {
                document.getElementById("idForTour").classList.remove("taketour")
            }
            dispatch(updateTourAndGuideComplete({
                module: "updateTourAndGuideComplete",
                postData: {
                    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    complete_tour: 1
                }
            }))
            dispatch(setShowMoreMenuReq(false))
            navigate("/home")

        }

        if (index === 0) {
            dispatch(setShowDropDown(true))
        }

        if (action === 'next') {
            console.log(lifecycle, step.target)

            if (lifecycle === 'complete' && step.target === '#idCoursesWeb') {
                dispatch(setJoyRideReq({ run: false, }))
                dispatch(setShowDropDown(false))
                navigate('/learn/courses?tab=1');
            }

            if (lifecycle === 'complete' && step.target === '#idCourseList') {
                sessionStorage.setItem('moduleForTour', '/moduleDetail/hgjhg')
                navigate('/moduleDetail/hgjhg');
            }

            if (lifecycle === 'complete' && step.target === '#idModuleDetail') {

                dispatch(setJoyRideReq({ run: false, }))
                dispatch(setShowDropDown(false))
                navigate('/learn/videos');
            }

            if (lifecycle === 'complete' && step.target === '#idVideosMenu') {
                navigate('/learn/coaching');
            }

            if (lifecycle === 'complete' && step.target === '#idCoachingMenu') {
                navigate('/learn/certifications');
            }

            if (lifecycle === 'complete' && step.target === '#idCertificationsMenu') {
                navigate('/learn/roleplay');
            }

            if (lifecycle === 'complete' && step.target === '#idRolePlayMyResponse') {

                const stepIndex = getStepIndex('#idEventsMenu', userRole, isPremiumUser, isGuest);
                dispatch(setJoyRideReq({ run: false, }))
                navigate("/learn/events");
                setTimeout(() => {
                    dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }))
                }, 1000)

            }

            if (lifecycle === 'complete' && step.target === '#idEventListing') {
                navigate("/learn/combo");
                setTimeout(() => {
                    window.scrollTo(0, 0)
                }, 1000)
            }


            if (lifecycle === 'complete' && step.target === '#idComboMenu') {
                navigate('/our-partners');
            }


            if (lifecycle === 'complete' && step.target === '#idLiveBtnMenu') {
                setTimeout(() => {
                    var lastElement = document.querySelector('[aria-label="Last"]');
                    if (lastElement !== null) {
                        lastElement.style.fontWeight = "700";
                    }
                }, 1500)
            }

            if (lifecycle === 'complete' && step.target === '#idSearchMenu') {
                dispatch(setJoyRideReq({ run: false, }))
                navigate("/home");
                setTimeout(() => {
                    const stepIndex = getStepIndex('#idCartMenu', userRole, isPremiumUser, isGuest);
                    dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }))
                }, 1000)
            }



            if (lifecycle === 'complete' && step.target === '#idYourRoleplay') {

                const stepIndex = getStepIndex('#idRolePlayMyResponse', userRole, isPremiumUser, isGuest);
                dispatch(setJoyRideReq({ run: false, }))
                navigate("/learn/roleplay/detailForTour/");
                setTimeout(() => {
                    dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }))
                }, 1000)
            }



        }

        console.log('tourAndGuide', data)

        if (action === 'prev') {


            if (lifecycle === 'complete' && step.target === '#idPartnerMenu') {
                let stepIndex = getStepIndex('#idComboMenu', userRole, isPremiumUser, isGuest)
                navigate("/learn/combo");
                setTimeout(() => {
                    dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }))
                }, 1000)
            }


            if (lifecycle === 'complete' && step.target === '#idComboMenu') {
                let stepIndex = getStepIndex('#idEventListing', userRole, isPremiumUser, isGuest)
                navigate("/learn/events");
                setTimeout(() => {
                    dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }))
                }, 1000)
            }


            if (lifecycle === 'complete' && step.target === '#idEventsMenu') {
                let stepIndex = getStepIndex('#idRolePlayMyResponse', userRole, isPremiumUser, isGuest)
                navigate("/learn/roleplay/detailForTour/");
                setTimeout(() => {
                    dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }))
                }, 1000)
            }

            if (lifecycle === 'complete' && step.target === '#idRolePlayMyResponse') {
                let stepIndex = getStepIndex('#idYourRoleplay', userRole, isPremiumUser, isGuest)
                navigate("/learn/roleplay");
                setTimeout(() => {
                    dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }))
                }, 1000)
            }


            if (lifecycle === 'complete' && step.target === '#idVideosMenu') {
                let stepIndex = getStepIndex('#idModuleDetail', userRole, isPremiumUser, isGuest)
                navigate("/moduleDetail/KEYMWBBKHY");
                setTimeout(() => {
                    dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }))
                }, 1000)
            }

            if (lifecycle === 'complete' && step.target === '#idModuleDetail') {
                let stepIndex = getStepIndex('#idCourseList', userRole, isPremiumUser, isGuest)
                navigate("/learn/courses?tab=1");
                setTimeout(() => {
                    dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }))
                }, 1000)
            }

            if (lifecycle === 'complete' && step.target === '#idCoursesMenu') {
                let stepIndex = getStepIndex('#idCoursesWeb', userRole, isPremiumUser, isGuest)
                navigate('/home');
                dispatch(setShowDropDown(true))
                setTimeout(() => {

                    dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }))
                }, 1000)

            }













        }


        if (finishedStatuses.includes(status) || action === 'close' || action === 'stop') {
            dispatch(setJoyRideReq({ run: false, stepIndex: 0 }))
            dispatch(setShowDropDown(false))
            sessionStorage.setItem(SessionKeys.IS_TOUR, "NO")
            if (document.getElementById("idForTour") !== null) {
                document.getElementById("idForTour").classList.remove("taketour")
            }
            dispatch(updateTourAndGuideComplete({
                module: "updateTourAndGuideComplete",
                postData: {
                    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    complete_tour: 1
                }
            }))
            navigate("/home")

        }
    };
    useEffect(() => {
        console.log('joyRideRes:', joyRideRes,)
        if (joyRideRes?.run) {
            if (document.getElementById("idForTour") !== null) {
                document.getElementById("idForTour").classList.add("taketour")
            }
        }
        if (!_.isEmpty(joyRideRes) && showMenu) {
            handleClickStart(joyRideRes)
        }
    }, [joyRideRes])

    const handleClickStart = (joyRideRes) => {
        console.log('start joyride', joyRideRes);
        // if (sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES") {
        setJoyState(joyRideRes);
        // }
    };

    const renderLoginSignup = () => {
        return (
            <div className="without-log-btn d-flex">
                <FormButtonComponent
                    btnName="Sign in"
                    leftIcon=""
                    rightIcon=""
                    btnAction={() => {
                        clickStreamUser('clicked-login-btn', {
                            is_guest_user: true,
                            session_id: localStorage.getItem('sessionId')
                        })
                        let locationPath = getCurrentLocationPath(location)
                        if(isMainDomain()){
                        navigate("/verify-user",{state:locationPath})// navigate('/login')
                        }else{
                            navigate("/login",{state:locationPath})
                        }
                    }}
                    isPrimary={false}
                    replaceClassName={"login-btn-header"}
                />
                {isMainDomain() && <FormButtonComponent
                    btnName="Sign up"
                    leftIcon=""
                    rightIcon=""
                    btnAction={() => {
                        clickStreamUser('clicked-login-btn', {
                            is_guest_user: true,
                            session_id: localStorage.getItem('sessionId')
                        })
                        navigate('/sign-up?p=1')
                    }}
                    isPrimary={true}
                    replaceClassName={"sign-up-btn-header"}
                />}
            </div>
        )
    }

    const [toastShow, setToastShow] = useState(false);

  const addToWishlistResponse = useSelector((state) => state.product.addToWishList);
  const removeFromWishListResponse = useSelector((state) => state.product.removeWishListData);
  const [message, setMessage] = useState("");

  const loaderResponse = useSelector((state)=> state.home.showLoader);

  useEffect(() => {
    if(loaderResponse === "true")
        {
            setIsLoading(true);
        }
  }, [loaderResponse]);

  useEffect(() => {
    console.log('wishlistres--',addToWishlistResponse);
    if(!_.isEmpty(addToWishlistResponse) && loaderResponse === "true")
      {
    if(document.getElementById("idForTour")!==null){
        document.getElementById("idForTour").click();
      }
        if(addToWishlistResponse?.status === "success")
          {
            setIsLoading(false);
            setToastShow(true);
            setMessage(addToWishlistResponse?.payload?.message);
          }
          else
          {
            setIsLoading(false);
            setToastShow(true);
            setMessage(addToWishlistResponse?.error?.message);
          }
      }
      setIsLoading(false);
      dispatch(getShowLoader("false"));
  }, [addToWishlistResponse]);

  useEffect(() => {
    console.log('wishlistres--',removeFromWishListResponse);
    if(!_.isEmpty(removeFromWishListResponse) && loaderResponse === "true")
      {
    if(document.getElementById("idForTour")!==null){
        document.getElementById("idForTour").click();
      }
        if(removeFromWishListResponse?.status === "success")
          {
            setIsLoading(false);
            setToastShow(true);
            setMessage(removeFromWishListResponse?.payload?.message);
          }
          else
          {
            setIsLoading(false);
            setToastShow(true);
            setMessage(removeFromWishListResponse?.error?.message);
          }
      }
      setIsLoading(false);
      dispatch(getShowLoader("false"));
  }, [removeFromWishListResponse]);


    return (
        <>
            <Loader start={isLoading} />
            <ChatBotComponent />
            <CalendarLogicComponent />
            {showMenu && <Joyride
                callback={handleJoyrideCallback}
                continuous
                hideCloseButton
                run={joyState.run}
                scrollToFirstStep
                showProgress
                showSkipButton
                stepIndex={joyState.stepIndex}
                steps={getJoyRideScript(userRole, isPremiumUser, isGuest)}
                styles={{
                    options: {
                        zIndex: 10000,
                    },
                }}
            />}
            {/* <div className="h-4">
                <div className="header-borderThin position-fixed w-100"></div>
            </div> */}
            {showAllMenu ? (
                <div className="  d-flex mt24 mbtop">
                    {/* <NavDropdown
              className="notification-nav"
              title={
                <svg
                  xmlnsXlink="http://www.w3.org/2000/svg"
                  width="13.163"
                  height="16.463"
                  viewBox="0 0 13.163 16.463"
                >
                  <g
                    id="Icon_ionic-ios-notifications"
                    data-name="Icon ionic-ios-notifications"
                    transform="translate(-6.761 -3.93)"
                  >
                    <path
                      id="Path_3370"
                      data-name="Path 3370"
                      d="M16.587,30.517a1.94,1.94,0,0,0,1.979-2.181H14.6A1.941,1.941,0,0,0,16.587,30.517Z"
                      transform="translate(-3.253 -10.123)"
                    />
                    <path
                      id="Path_3371"
                      data-name="Path 3371"
                      d="M19.757,16.123c-.634-.835-1.88-1.325-1.88-5.065,0-3.839-1.7-5.382-3.275-5.752-.148-.037-.255-.086-.255-.243V4.943a1,1,0,1,0-2.008,0v.119c0,.152-.107.206-.255.243-1.584.374-3.275,1.913-3.275,5.752,0,3.74-1.247,4.226-1.88,5.065a.817.817,0,0,0,.654,1.309H19.107A.817.817,0,0,0,19.757,16.123Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </svg>
              }
            >
              <NavDropdown.Item className="get_CertifiedContainer dropdownItem_notiFcation ">
                <div className="getCertified">
                  <a href="#">
                    {" "}
                    <img
                      src="/images/get_certified01.jpg"
                      width="25px"
                      height="25px"
                      alt=""
                    />
                  </a>
                </div>
                <div className="getCertified_content">
                  <h6>Vivamus fringilla Mauris tristique</h6>
                  <p> Accepted your request 3 day ago</p>
                </div>
              </NavDropdown.Item>
              <NavDropdown.Item className="get_CertifiedContainer dropdownItem_notiFcation ">
                <div className="getCertified">
                  <a href="#">
                    {" "}
                    <img
                      src="/images/get_certified02.jpg"
                      width="25px"
                      height="25px"
                      alt=""
                    />
                  </a>
                </div>
                <div className="getCertified_content">
                  <h6>Quisque vitae commodo turpis.</h6>
                  <p> Accepted your request 3 day ago</p>
                </div>
              </NavDropdown.Item>
              <NavDropdown.Item className="get_CertifiedContainer dropdownItem_notiFcation ">
                <div className="getCertified">
                  <a href="#">
                    {" "}
                    <img
                      src="/images/get_certified03.jpg"
                      width="25px"
                      height="25px"
                      alt=""
                    />
                  </a>
                </div>
                <div className="getCertified_content">
                  <h6>Etiam laoreet, lectus ut euismod.</h6>
                  <p> Accepted your request 3 day ago</p>
                </div>
              </NavDropdown.Item>

              <div className="getCertified buutndf">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  <button
                    type="button"
                    className="btn btn-primary btn-block setup-button markAll_btn"
                  >
                    Mark all as read
                  </button>
                </a>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  <button className="getNotFieedbutton">
                    Show unread only
                  </button>
                </a>
              </div>
            </NavDropdown> */}
                    <div className="mob-cal nav-item navbar_custom">
                        <a
                            className="nav-link position-relative"
                            role="button"
                            data-bs-toggle="dropdown"
                            href="#"
                            title="Calendar"
                            data-title="Calendar"
                        >
                            <svg
                                xmlnsXlink="http://www.w3.org/2000/svg"
                                width="15.109"
                                height="17.267"
                                viewBox="0 0 15.109 17.267"
                                onClick={() => {
                                    navigate("/events-calendar");
                                    clickStreamUser("calendar-events-button-clicked", {
                                        userId: authBroker?.payload?.user.user_id,
                                    });
                                }
                                }
                            >
                                <path
                                    id="Icon_awesome-calendar-alt"
                                    data-name="Icon awesome-calendar-alt"
                                    d="M0,15.648a1.619,1.619,0,0,0,1.619,1.619H13.49a1.619,1.619,0,0,0,1.619-1.619V6.475H0Zm10.792-6.61a.406.406,0,0,1,.4-.4h1.349a.406.406,0,0,1,.4.4v1.349a.406.406,0,0,1-.4.4H11.2a.406.406,0,0,1-.4-.4Zm0,4.317a.406.406,0,0,1,.4-.4h1.349a.406.406,0,0,1,.4.4V14.7a.406.406,0,0,1-.4.4H11.2a.406.406,0,0,1-.4-.4ZM6.475,9.038a.406.406,0,0,1,.4-.4H8.229a.406.406,0,0,1,.4.4v1.349a.406.406,0,0,1-.4.4H6.88a.406.406,0,0,1-.4-.4Zm0,4.317a.406.406,0,0,1,.4-.4H8.229a.406.406,0,0,1,.4.4V14.7a.406.406,0,0,1-.4.4H6.88a.406.406,0,0,1-.4-.4ZM2.158,9.038a.406.406,0,0,1,.4-.4H3.912a.406.406,0,0,1,.4.4v1.349a.406.406,0,0,1-.4.4H2.563a.406.406,0,0,1-.4-.4Zm0,4.317a.406.406,0,0,1,.4-.4H3.912a.406.406,0,0,1,.4.4V14.7a.406.406,0,0,1-.4.4H2.563a.406.406,0,0,1-.4-.4ZM13.49,2.158H11.871V.54a.541.541,0,0,0-.54-.54H10.252a.541.541,0,0,0-.54.54V2.158H5.4V.54A.541.541,0,0,0,4.856,0H3.777a.541.541,0,0,0-.54.54V2.158H1.619A1.619,1.619,0,0,0,0,3.777V5.4H15.109V3.777A1.619,1.619,0,0,0,13.49,2.158Z"
                                />
                            </svg>
                            {userRole != "realtor" && sessionCount > 0 ? (
                                <span className="session-badge">{sessionCount}</span>
                            ) : (
                                ""
                            )}
                        </a>
                    </div>

                    <form className="d-flex navbar_custom">
                        <button
                            className="btn searchBtn"
                            type="button"
                            onClick={() => {
                                navigate("/search");
                            }}
                            title="Search"
                            data-title="Search"
                        >
                            <svg
                                xmlnsXlink="http://www.w3.org/2000/svg"
                                width="19.163"
                                height="19.085"
                                viewBox="0 0 19.163 19.085"
                            >
                                <path
                                    id="Icon_awesome-search"
                                    data-name="Icon awesome-search"
                                    d="M17.836,15.636l-3.521-3.521a.847.847,0,0,0-.6-.247h-.576a7.343,7.343,0,1,0-1.271,1.271v.576a.847.847,0,0,0,.247.6l3.521,3.521a.844.844,0,0,0,1.2,0l1-1A.852.852,0,0,0,17.836,15.636ZM7.346,11.867a4.521,4.521,0,1,1,4.521-4.521A4.518,4.518,0,0,1,7.346,11.867Z"
                                    transform="translate(0.5 0.5)"
                                    stroke="#fff"
                                    strokeWidth="1"
                                />
                            </svg>
                        </button>
                    </form>
                    <div className="nav-item dropdown streamlive livestrembtn  ">
                        <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            role="button"
                            data-bs-toggle="dropdown"
                        >
                            {/* <LiveButtonComponent /> */}
                            <LiveMenuComponent />

                        </a>
                    </div>

                </div>
            ) : (
                ""
            )}
            <div className=" content-logo mobileViewIcons">
                <div className="mobilenav">
                    {/* {location.pathname.includes("/courseDetail") ||
                        !showAllMenu ? (
                        <div className="open pr-3">
                            <button
                                className="openbtn"
                                id="openbtn"
                                ref={hamburgerMenu}
                                onClick={() => {
                                    toggleNav();
                                }}
                            >
                                <span className="closetoogle"></span>
                            </button>
                        </div>
                    ) : (
                        ""
                    )} */}

                    {showAllMenu ? (
                        <>
                            <div className="mobileViewIconsDetails ">
                                <ul className="navbar-nav profile_thumbImg moDeviceAvtaar d-flex flex-row align-items-center">
                                    <li className="nav-item dropdown navbar_custom">
                                        <span
                                            className="nav-link MoHamger"
                                            onClick={() => {
                                                if (!showMobMenu) {
                                                    setShowMobMenu(true);
                                                } else {
                                                    setShowMobMenu(false);
                                                }
                                            }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                            >
                                                <g
                                                    id="Group_5736"
                                                    data-name="Group 5736"
                                                    transform="translate(-18 -51)"
                                                >
                                                    <circle
                                                        id="Ellipse_249"
                                                        data-name="Ellipse 249"
                                                        cx="2"
                                                        cy="2"
                                                        r="2"
                                                        transform="translate(18 51)"
                                                    ></circle>
                                                    <circle
                                                        id="Ellipse_254"
                                                        data-name="Ellipse 254"
                                                        cx="2"
                                                        cy="2"
                                                        r="2"
                                                        transform="translate(18 57)"
                                                    ></circle>
                                                    <circle
                                                        id="Ellipse_257"
                                                        data-name="Ellipse 257"
                                                        cx="2"
                                                        cy="2"
                                                        r="2"
                                                        transform="translate(18 63)"
                                                    ></circle>
                                                    <circle
                                                        id="Ellipse_250"
                                                        data-name="Ellipse 250"
                                                        cx="2"
                                                        cy="2"
                                                        r="2"
                                                        transform="translate(30 51)"
                                                    ></circle>
                                                    <circle
                                                        id="Ellipse_252"
                                                        data-name="Ellipse 252"
                                                        cx="2"
                                                        cy="2"
                                                        r="2"
                                                        transform="translate(30 57)"
                                                    ></circle>
                                                    <circle
                                                        id="Ellipse_255"
                                                        data-name="Ellipse 255"
                                                        cx="2"
                                                        cy="2"
                                                        r="2"
                                                        transform="translate(30 63)"
                                                    ></circle>
                                                    <circle
                                                        id="Ellipse_251"
                                                        data-name="Ellipse 251"
                                                        cx="2"
                                                        cy="2"
                                                        r="2"
                                                        transform="translate(24 51)"
                                                    ></circle>
                                                    <circle
                                                        id="Ellipse_253"
                                                        data-name="Ellipse 253"
                                                        cx="2"
                                                        cy="2"
                                                        r="2"
                                                        transform="translate(24 57)"
                                                    ></circle>
                                                    <circle
                                                        id="Ellipse_256"
                                                        data-name="Ellipse 256"
                                                        cx="2"
                                                        cy="2"
                                                        r="2"
                                                        transform="translate(24 63)"
                                                    ></circle>
                                                </g>
                                            </svg>
                                        </span>
                                        {showMobMenu ? (
                                            <ul className="dropdown-menu menu-cont certy_cont M0Hamburger">
                                                {userRole != "host" && userRole != "instructor" ? (
                                                    <>

                                                        <li className={`nav-item item-underline navbar_custom 
                        ${activeMenu === 'home' ? 'active' : ''}`}>
                                                            <a
                                                                className="nav-link"
                                                                onClick={() => {
                                                                    dispatch(getSelectedCatId(""));
                                                                    navigate(
                                                                        `/home`
                                                                    );
                                                                }}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                                                                    <path d="M2.05714 15.9429H5.14286V10.8C5.14286 10.5086 5.24143 10.2643 5.43857 10.0671C5.63571 9.87 5.88 9.77143 6.17143 9.77143H10.2857C10.5771 9.77143 10.8214 9.87 11.0186 10.0671C11.2157 10.2643 11.3143 10.5086 11.3143 10.8V15.9429H14.4V6.68571L8.22857 2.05714L2.05714 6.68571V15.9429ZM0 15.9429V6.68571C0 6.36 0.0728571 6.05143 0.218571 5.76C0.364286 5.46857 0.565714 5.22857 0.822857 5.04L6.99429 0.411429C7.35429 0.137143 7.76571 0 8.22857 0C8.69143 0 9.10286 0.137143 9.46286 0.411429L15.6343 5.04C15.8914 5.22857 16.0929 5.46857 16.2386 5.76C16.3843 6.05143 16.4571 6.36 16.4571 6.68571V15.9429C16.4571 16.5086 16.2557 16.9929 15.8529 17.3957C15.45 17.7986 14.9657 18 14.4 18H10.2857C9.99429 18 9.75 17.9014 9.55286 17.7043C9.35571 17.5071 9.25714 17.2629 9.25714 16.9714V11.8286H7.2V16.9714C7.2 17.2629 7.10143 17.5071 6.90429 17.7043C6.70714 17.9014 6.46286 18 6.17143 18H2.05714C1.49143 18 1.00714 17.7986 0.604286 17.3957C0.201429 16.9929 0 16.5086 0 15.9429Z" fill="#292D32" />
                                                                </svg>
                                                                Home
                                                            </a>
                                                        </li>


                                                        <li id="idCoursesWeb" className={`nav-item item-underline navbar_custom 
                                                    ${activeMenu === 'learn' ? 'active' : ''}`}>
                                                            <a
                                                                className="nav-link"
                                                                onClick={() => {
                                                                    clickStreamUser("xsel-coaching-menu-clicked", {
                                                                        userId: auth.authBroker?.payload?.user.user_id,
                                                                    });
                                                                    dispatch(getActiveHeader("learn"))
                                                                    navigate("/learn/courses?tab=1");
                                                                }}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                                                                    <path d="M9 21.5C7.8 20.3667 6.425 19.5 4.875 18.9C3.325 18.3 1.7 18 0 18V7C1.68333 7 3.3 7.30417 4.85 7.9125C6.4 8.52083 7.78333 9.4 9 10.55C10.2167 9.4 11.6 8.52083 13.15 7.9125C14.7 7.30417 16.3167 7 18 7V18C16.2833 18 14.6542 18.3 13.1125 18.9C11.5708 19.5 10.2 20.3667 9 21.5ZM9 18.9C10.05 18.1167 11.1667 17.4917 12.35 17.025C13.5333 16.5583 14.75 16.25 16 16.1V9.2C14.7833 9.41667 13.5875 9.85417 12.4125 10.5125C11.2375 11.1708 10.1 12.05 9 13.15C7.9 12.05 6.7625 11.1708 5.5875 10.5125C4.4125 9.85417 3.21667 9.41667 2 9.2V16.1C3.25 16.25 4.46667 16.5583 5.65 17.025C6.83333 17.4917 7.95 18.1167 9 18.9ZM9 8C7.9 8 6.95833 7.60833 6.175 6.825C5.39167 6.04167 5 5.1 5 4C5 2.9 5.39167 1.95833 6.175 1.175C6.95833 0.391667 7.9 0 9 0C10.1 0 11.0417 0.391667 11.825 1.175C12.6083 1.95833 13 2.9 13 4C13 5.1 12.6083 6.04167 11.825 6.825C11.0417 7.60833 10.1 8 9 8ZM9 6C9.55 6 10.0208 5.80417 10.4125 5.4125C10.8042 5.02083 11 4.55 11 4C11 3.45 10.8042 2.97917 10.4125 2.5875C10.0208 2.19583 9.55 2 9 2C8.45 2 7.97917 2.19583 7.5875 2.5875C7.19583 2.97917 7 3.45 7 4C7 4.55 7.19583 5.02083 7.5875 5.4125C7.97917 5.80417 8.45 6 9 6Z" fill="#292D32" />
                                                                </svg>
                                                                Learn
                                                            </a>
                                                        </li>


                                                        <li id="idPartnerMenu" className={`nav-item item-underline navbar_custom 
                                                    ${activeMenu === 'our-partners' ? 'active' : ''}`}>
                                                            <a
                                                                className="nav-link"
                                                                onClick={() => {
                                                                    clickStreamUser("xsel-coaching-menu-clicked", {
                                                                        userId: auth.authBroker?.payload?.user.user_id,
                                                                    });
                                                                    navigate("/our-partners");
                                                                }}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M11.875 20C11.9417 20 12.0083 19.9833 12.075 19.95C12.1417 19.9167 12.1917 19.8833 12.225 19.85L20.425 11.65C20.625 11.45 20.7708 11.225 20.8625 10.975C20.9542 10.725 21 10.475 21 10.225C21 9.95833 20.9542 9.70417 20.8625 9.4625C20.7708 9.22083 20.625 9.00833 20.425 8.825L16.175 4.575C15.9917 4.375 15.7792 4.22917 15.5375 4.1375C15.2958 4.04583 15.0417 4 14.775 4C14.525 4 14.275 4.04583 14.025 4.1375C13.775 4.22917 13.55 4.375 13.35 4.575L13.075 4.85L14.925 6.725C15.175 6.95833 15.3583 7.225 15.475 7.525C15.5917 7.825 15.65 8.14167 15.65 8.475C15.65 9.175 15.4125 9.7625 14.9375 10.2375C14.4625 10.7125 13.875 10.95 13.175 10.95C12.8417 10.95 12.5208 10.8917 12.2125 10.775C11.9042 10.6583 11.6333 10.4833 11.4 10.25L9.52499 8.4L5.14999 12.775C5.09999 12.825 5.06249 12.8792 5.03749 12.9375C5.01249 12.9958 4.99999 13.0583 4.99999 13.125C4.99999 13.2583 5.04999 13.3792 5.14999 13.4875C5.24999 13.5958 5.36666 13.65 5.49999 13.65C5.56666 13.65 5.63332 13.6333 5.69999 13.6C5.76666 13.5667 5.81666 13.5333 5.84999 13.5L9.24999 10.1L10.65 11.5L7.27499 14.9C7.22499 14.95 7.18749 15.0042 7.16249 15.0625C7.13749 15.1208 7.12499 15.1833 7.12499 15.25C7.12499 15.3833 7.17499 15.5 7.27499 15.6C7.37499 15.7 7.49166 15.75 7.62499 15.75C7.69166 15.75 7.75832 15.7333 7.82499 15.7C7.89166 15.6667 7.94166 15.6333 7.97499 15.6L11.375 12.225L12.775 13.625L9.39999 17.025C9.34999 17.0583 9.31249 17.1083 9.28749 17.175C9.26249 17.2417 9.24999 17.3083 9.24999 17.375C9.24999 17.5083 9.29999 17.625 9.39999 17.725C9.49999 17.825 9.61666 17.875 9.74999 17.875C9.81666 17.875 9.87916 17.8625 9.93749 17.8375C9.99582 17.8125 10.05 17.775 10.1 17.725L13.5 14.35L14.9 15.75L11.5 19.15C11.45 19.2 11.4125 19.2542 11.3875 19.3125C11.3625 19.3708 11.35 19.4333 11.35 19.5C11.35 19.6333 11.4042 19.75 11.5125 19.85C11.6208 19.95 11.7417 20 11.875 20ZM11.85 22C11.2333 22 10.6875 21.7958 10.2125 21.3875C9.73749 20.9792 9.45832 20.4667 9.37499 19.85C8.80832 19.7667 8.33332 19.5333 7.94999 19.15C7.56666 18.7667 7.33332 18.2917 7.24999 17.725C6.68332 17.6417 6.21249 17.4042 5.83749 17.0125C5.46249 16.6208 5.23332 16.15 5.14999 15.6C4.51666 15.5167 3.99999 15.2417 3.59999 14.775C3.19999 14.3083 2.99999 13.7583 2.99999 13.125C2.99999 12.7917 3.06249 12.4708 3.18749 12.1625C3.31249 11.8542 3.49166 11.5833 3.72499 11.35L9.52499 5.575L12.8 8.85C12.8333 8.9 12.8833 8.9375 12.95 8.9625C13.0167 8.9875 13.0833 9 13.15 9C13.3 9 13.425 8.95417 13.525 8.8625C13.625 8.77083 13.675 8.65 13.675 8.5C13.675 8.43333 13.6625 8.36667 13.6375 8.3C13.6125 8.23333 13.575 8.18333 13.525 8.15L9.94999 4.575C9.76666 4.375 9.55416 4.22917 9.31249 4.1375C9.07082 4.04583 8.81666 4 8.54999 4C8.29999 4 8.04999 4.04583 7.79999 4.1375C7.54999 4.22917 7.32499 4.375 7.12499 4.575L3.59999 8.125C3.44999 8.275 3.32499 8.45 3.22499 8.65C3.12499 8.85 3.05832 9.05 3.02499 9.25C2.99166 9.45 2.99166 9.65417 3.02499 9.8625C3.05832 10.0708 3.12499 10.2667 3.22499 10.45L1.77499 11.9C1.49166 11.5167 1.28332 11.0958 1.14999 10.6375C1.01666 10.1792 0.966657 9.71667 0.99999 9.25C1.03332 8.78333 1.14999 8.32917 1.34999 7.8875C1.54999 7.44583 1.82499 7.05 2.17499 6.7L5.69999 3.175C6.09999 2.79167 6.54582 2.5 7.03749 2.3C7.52916 2.1 8.03332 2 8.54999 2C9.06666 2 9.57082 2.1 10.0625 2.3C10.5542 2.5 10.9917 2.79167 11.375 3.175L11.65 3.45L11.925 3.175C12.325 2.79167 12.7708 2.5 13.2625 2.3C13.7542 2.1 14.2583 2 14.775 2C15.2917 2 15.7958 2.1 16.2875 2.3C16.7792 2.5 17.2167 2.79167 17.6 3.175L21.825 7.4C22.2083 7.78333 22.5 8.225 22.7 8.725C22.9 9.225 23 9.73333 23 10.25C23 10.7667 22.9 11.2708 22.7 11.7625C22.5 12.2542 22.2083 12.6917 21.825 13.075L13.625 21.25C13.3917 21.4833 13.1208 21.6667 12.8125 21.8C12.5042 21.9333 12.1833 22 11.85 22Z" fill="black" />
                                                                </svg>
                                                               {authBroker?.payload?.user?.config?.partner_menu_text !== undefined && !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)?
                                                               authBroker?.payload?.user?.config?.partner_menu_text:
                                                               "Learning Partners"} 
                                                            </a>
                                                        </li>
                                                        {showHeaderMenu.subscription ?
                                                            <li id="idPartnerMenu" className={`nav-item item-underline navbar_custom 
                                                                ${activeMenu === 'subscriptions' ? 'active' : ''}`}>
                                                                <a
                                                                    className="nav-link"
                                                                    onClick={() => {
                                                                        clickStreamUser("xsel-coaching-menu-clicked", {
                                                                            userId: auth.authBroker?.payload?.user.user_id,
                                                                        });
                                                                        navigate("/subscription");
                                                                    }}
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                        <path d="M8.85 17.825L12 15.925L15.15 17.85L14.325 14.25L17.1 11.85L13.45 11.525L12 8.125L10.55 11.5L6.9 11.825L9.675 14.25L8.85 17.825ZM5.825 22L7.45 14.975L2 10.25L9.2 9.625L12 3L14.8 9.625L22 10.25L16.55 14.975L18.175 22L12 18.275L5.825 22Z" fill="black" />
                                                                    </svg>
                                                                    Subscriptions
                                                                </a>
                                                            </li> : ""}

                                                    </>
                                                ) : (
                                                    ""
                                                )}

                                            </ul>
                                        ) : (
                                            ""
                                        )}
                                    </li>
                                </ul>
                            </div>

                        </>
                    ) : (
                        ""
                    )}
                </div>
                <div className="mobcenterlogo">
                    <a className="navbar-brand" href="/home">
                        <img
                            id="niit_logo_mob"
                            className="niit_moblogo"
                            src={logo ? logo : "/images/LOGO_head.png"}
                            width="70"
                            alt="logo"
                        />
                    </a>
                </div>
                {showAllMenu ? (
                    <div className="top-bar d-flex mt24">
                        <ul className="mobnotify">
                            <Notification />
                        </ul>

                        <ul className={scroll ? "navbar-nav profile_thumbImg moDeviceAvtaar scrolledmob" : "navbar-nav profile_thumbImg moDeviceAvtaar"}>
                            <li className="nav-item">
                                <ProfileMenuSection from={"Mobile"} signOut={signOut} renderLoginSignup={renderLoginSignup}/>
                                {/* <span className="wlcmtxt" title={name}>Welcome <span className="nameusershow">{name}</span></span> */}
                            </li>
                        </ul>
                    </div>
                ) : (
                    ""
                )}
            </div>
            <nav className={scroll ? "navbar navbar-expand-lg bg-menu-lightWhite scrollnavmob" : "navbar navbar-expand-lg bg-menu-lightWhite"}>
                <div className="bg-menu-lightWhite w-100">
                    <div className="container content-profile d-flex h-100 align-items-center justify-content-between">
                        <div className="logn-box">
                            {/* {location.pathname.includes("/courseDetail") ||
                                !showAllMenu ? (
                                <div className="opens pr-3">
                                    <button
                                        className="openbtn"
                                        id="openbtnd"
                                        ref={hamburgerMenu}
                                        onClick={() => {
                                            toggleNavDesktop();
                                        }}
                                    >
                                        <span id="forHandleBurgerMenu" className="closetoogle closeopen"></span>
                                    </button>
                                </div>
                            ) : (
                                ""
                            )} */}
                            <div
                                className=" content-logo"
                                onClick={() => {
                                    navigate("/home");
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <a className="navbar-brand cursor-pointer">
                                    <img
                                        className="niit_logo"
                                        src={logo ? logo : "/images/LOGO_head.png"}

                                    />

                                </a>
                                {false && <span className="user-sub" style={{ color: "#D0CDE1" }}>PLATINUM</span>}
                            </div>
                            {showAllMenu ? (
                                <>


                                    <div
                                        className="collapse navbar-collapse justify-content-between"
                                        id="collapsibleNavbar"
                                    >
                                        <ul
                                            className={`navbar-nav btocnav ${userRole != "host" && userRole != "instructor"
                                                ? "justify-content-between"
                                                : "justify-content-end"
                                                }`}
                                            style={{ flex: 1 }}
                                        >
                                            {userRole != "host" && userRole != "instructor" ? (
                                                <>
                                                    {/* <li id={"idCoursesWeb"} className={`nav-item item-underline navbar_custom 
                        ${activeMenu === 'courses' ? 'active' : ''}`}>
                                                        <a
                                                            className="nav-link"
                                                            onClick={() => {
                                                                dispatch(getSelectedCatId(""));
                                                                navigate(
                                                                    `/course-categories`
                                                                );
                                                            }}
                                                        >
                                                            Courses
                                                        </a>
                                                    </li>
                                                    <li id="idVideosMenuWeb" className={`nav-item item-underline navbar_custom 
                        ${activeMenu === 'videos' ? 'active' : ''}`}>
                                                        <a
                                                            className="nav-link"
                                                            onClick={() => goToVideo()}
                                                        >
                                                            Videos
                                                        </a>
                                                    </li> */}
                                                    {/* <NavDropdown title="Courses">
                          {
                            <>
                              <NavDropdown.Item
                                className="customHover"
                                onClick={() => {
                                  dispatch(getSelectedCatId(""));
                                  navigate(
                                    `/courseListing?selectedCategory=&selectCourse=top`
                                  );
                                }}
                              >
                                All
                              </NavDropdown.Item>
                              <CategoryMenuProduct showMenu={showMenu} />
                              <CategoryMenuBroker showMenu={showMenu} />
                            </>
                          }
                        </NavDropdown> */}

                                                    {/* <NavDropdown title="Video Library"> */}
                                                    {/*<NavDropdown.Item
                            className="customHover"
                            href="news-articles"
                          >
                            News Articles
                          </NavDropdown.Item>*/}
                                                    {/* <NavDropdown.Item
                            className="customHover"
                            onClick={() => goToVideo()}
                          >
                            Videos
                          </NavDropdown.Item>
                        </NavDropdown> */}
                                                    {/* 
                                                    <li id="idRolePlayMenuWeb" className={`nav-item item-underline navbar_custom 
                                                    ${activeMenu === 'roleplay' ? 'active' : ''}`}>
                                                        <a
                                                            className="nav-link"
                                                            onClick={() => {
                                                                clickStreamUser("xsel-events-menu-clicked", {
                                                                    userId: auth.authBroker?.payload?.user.user_id,
                                                                });
                                                                goToRolePlay("my-role-plays")
                                                            }}
                                                        >
                                                            Role play
                                                        </a>
                                                    </li>
                                                    <li id="idEventsMenu" className={`nav-item item-underline navbar_custom 
                                                    ${activeMenu === 'events' ? 'active' : ''}`}>
                                                        <a
                                                            className="nav-link"
                                                            onClick={() => {
                                                                clickStreamUser("xsel-events-menu-clicked", {
                                                                    userId: auth.authBroker?.payload?.user.user_id,
                                                                });
                                                                navigate("/events?source=xsel");
                                                            }}
                                                        >
                                                            Events
                                                        </a>
                                                    </li> */}
                                                    {/* <NavDropdown title="RolePlay">
                          <NavDropdown.Item
                            className="customHover"
                            onClick={() => goToRolePlay("role-play")}
                          >
                            Participate in a RolePlay
                          </NavDropdown.Item>
                          {otherRole.includes("coach") && (
                            <NavDropdown.Item
                              className="customHover"
                              onClick={() => goToRolePlay("review-role-play")}
                            >
                              Review a RolePlay
                            </NavDropdown.Item>
                          )}
                          <NavDropdown.Item
                            className="customHover"
                            onClick={() => goToRolePlay("my-role-plays")}
                          >
                            My RolePlays
                          </NavDropdown.Item>
                        </NavDropdown> */}
                                                    {/* {certifiedList.length > 0 ?
                                                        <NavDropdown show={showCertMenu} id="idCertificationsMenu" title=" Certifications"
                                                            onClick={() => {
                                                                setShowCertMenu(!showCertMenu)
                                                            }}>
                                                            {certifiedList.map((cert, index) => {
                                                                return (
                                                                    <NavDropdown.Item
                                                                        onClick={() => goToCertifiedDetail(cert)}
                                                                        className="dropdownItem_getCertified customHover"
                                                                        key={`certlist-${index + 1}`}
                                                                    >
                                                                        {cert.name}
                                                                    </NavDropdown.Item>
                                                                );
                                                            })}
                                                        </NavDropdown> : ""
                                                    } */}
                                                    <li className={`nav-item item-underline navbar_custom 
                        ${activeMenu === 'home' ? 'active' : ''}`}>
                                                        <a
                                                            className="nav-link"
                                                            onClick={() => {
                                                                dispatch(getSelectedCatId(""));
                                                                navigate(
                                                                    `/home`
                                                                );
                                                            }}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                                                                <path d="M2.05714 15.9429H5.14286V10.8C5.14286 10.5086 5.24143 10.2643 5.43857 10.0671C5.63571 9.87 5.88 9.77143 6.17143 9.77143H10.2857C10.5771 9.77143 10.8214 9.87 11.0186 10.0671C11.2157 10.2643 11.3143 10.5086 11.3143 10.8V15.9429H14.4V6.68571L8.22857 2.05714L2.05714 6.68571V15.9429ZM0 15.9429V6.68571C0 6.36 0.0728571 6.05143 0.218571 5.76C0.364286 5.46857 0.565714 5.22857 0.822857 5.04L6.99429 0.411429C7.35429 0.137143 7.76571 0 8.22857 0C8.69143 0 9.10286 0.137143 9.46286 0.411429L15.6343 5.04C15.8914 5.22857 16.0929 5.46857 16.2386 5.76C16.3843 6.05143 16.4571 6.36 16.4571 6.68571V15.9429C16.4571 16.5086 16.2557 16.9929 15.8529 17.3957C15.45 17.7986 14.9657 18 14.4 18H10.2857C9.99429 18 9.75 17.9014 9.55286 17.7043C9.35571 17.5071 9.25714 17.2629 9.25714 16.9714V11.8286H7.2V16.9714C7.2 17.2629 7.10143 17.5071 6.90429 17.7043C6.70714 17.9014 6.46286 18 6.17143 18H2.05714C1.49143 18 1.00714 17.7986 0.604286 17.3957C0.201429 16.9929 0 16.5086 0 15.9429Z" fill="#292D32" />
                                                            </svg>
                                                            Home
                                                        </a>
                                                    </li>


                                                    <li id="idCoursesWeb" className={`nav-item item-underline navbar_custom 
                                                    ${activeMenu === 'learn' ? 'active' : ''}`}>
                                                        <a
                                                            className="nav-link"
                                                            onClick={() => {
                                                                clickStreamUser("xsel-coaching-menu-clicked", {
                                                                    userId: auth.authBroker?.payload?.user.user_id,
                                                                });
                                                                navigate("/learn/courses?tab=1");
                                                            }}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                                                                <path d="M9 21.5C7.8 20.3667 6.425 19.5 4.875 18.9C3.325 18.3 1.7 18 0 18V7C1.68333 7 3.3 7.30417 4.85 7.9125C6.4 8.52083 7.78333 9.4 9 10.55C10.2167 9.4 11.6 8.52083 13.15 7.9125C14.7 7.30417 16.3167 7 18 7V18C16.2833 18 14.6542 18.3 13.1125 18.9C11.5708 19.5 10.2 20.3667 9 21.5ZM9 18.9C10.05 18.1167 11.1667 17.4917 12.35 17.025C13.5333 16.5583 14.75 16.25 16 16.1V9.2C14.7833 9.41667 13.5875 9.85417 12.4125 10.5125C11.2375 11.1708 10.1 12.05 9 13.15C7.9 12.05 6.7625 11.1708 5.5875 10.5125C4.4125 9.85417 3.21667 9.41667 2 9.2V16.1C3.25 16.25 4.46667 16.5583 5.65 17.025C6.83333 17.4917 7.95 18.1167 9 18.9ZM9 8C7.9 8 6.95833 7.60833 6.175 6.825C5.39167 6.04167 5 5.1 5 4C5 2.9 5.39167 1.95833 6.175 1.175C6.95833 0.391667 7.9 0 9 0C10.1 0 11.0417 0.391667 11.825 1.175C12.6083 1.95833 13 2.9 13 4C13 5.1 12.6083 6.04167 11.825 6.825C11.0417 7.60833 10.1 8 9 8ZM9 6C9.55 6 10.0208 5.80417 10.4125 5.4125C10.8042 5.02083 11 4.55 11 4C11 3.45 10.8042 2.97917 10.4125 2.5875C10.0208 2.19583 9.55 2 9 2C8.45 2 7.97917 2.19583 7.5875 2.5875C7.19583 2.97917 7 3.45 7 4C7 4.55 7.19583 5.02083 7.5875 5.4125C7.97917 5.80417 8.45 6 9 6Z" fill="#292D32" />
                                                            </svg>
                                                            Learn
                                                        </a>
                                                    </li>
                                                    { /*<li id="idCoachingMenu" className={`nav-item item-underline navbar_custom 
                                                    ${activeMenu === 'coaching' ? 'active' : ''}`}>
                                                        <a
                                                            className="nav-link"
                                                            onClick={() => {
                                                                clickStreamUser("xsel-coaching-menu-clicked", {
                                                                    userId: auth.authBroker?.payload?.user.user_id,
                                                                });
                                                                navigate("/coaching");
                                                            }}
                                                        >
                                                            Coaching
                                                        </a>
                                                    </li> */}

                                                    <li id="idPartnerMenu" className={`nav-item item-underline navbar_custom 
                                                    ${activeMenu === 'our-partners' ? 'active' : ''}`}>
                                                        <a
                                                            className="nav-link"
                                                            onClick={() => {
                                                                clickStreamUser("xsel-coaching-menu-clicked", {
                                                                    userId: auth.authBroker?.payload?.user.user_id,
                                                                });
                                                                navigate("/our-partners");
                                                            }}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M11.875 20C11.9417 20 12.0083 19.9833 12.075 19.95C12.1417 19.9167 12.1917 19.8833 12.225 19.85L20.425 11.65C20.625 11.45 20.7708 11.225 20.8625 10.975C20.9542 10.725 21 10.475 21 10.225C21 9.95833 20.9542 9.70417 20.8625 9.4625C20.7708 9.22083 20.625 9.00833 20.425 8.825L16.175 4.575C15.9917 4.375 15.7792 4.22917 15.5375 4.1375C15.2958 4.04583 15.0417 4 14.775 4C14.525 4 14.275 4.04583 14.025 4.1375C13.775 4.22917 13.55 4.375 13.35 4.575L13.075 4.85L14.925 6.725C15.175 6.95833 15.3583 7.225 15.475 7.525C15.5917 7.825 15.65 8.14167 15.65 8.475C15.65 9.175 15.4125 9.7625 14.9375 10.2375C14.4625 10.7125 13.875 10.95 13.175 10.95C12.8417 10.95 12.5208 10.8917 12.2125 10.775C11.9042 10.6583 11.6333 10.4833 11.4 10.25L9.52499 8.4L5.14999 12.775C5.09999 12.825 5.06249 12.8792 5.03749 12.9375C5.01249 12.9958 4.99999 13.0583 4.99999 13.125C4.99999 13.2583 5.04999 13.3792 5.14999 13.4875C5.24999 13.5958 5.36666 13.65 5.49999 13.65C5.56666 13.65 5.63332 13.6333 5.69999 13.6C5.76666 13.5667 5.81666 13.5333 5.84999 13.5L9.24999 10.1L10.65 11.5L7.27499 14.9C7.22499 14.95 7.18749 15.0042 7.16249 15.0625C7.13749 15.1208 7.12499 15.1833 7.12499 15.25C7.12499 15.3833 7.17499 15.5 7.27499 15.6C7.37499 15.7 7.49166 15.75 7.62499 15.75C7.69166 15.75 7.75832 15.7333 7.82499 15.7C7.89166 15.6667 7.94166 15.6333 7.97499 15.6L11.375 12.225L12.775 13.625L9.39999 17.025C9.34999 17.0583 9.31249 17.1083 9.28749 17.175C9.26249 17.2417 9.24999 17.3083 9.24999 17.375C9.24999 17.5083 9.29999 17.625 9.39999 17.725C9.49999 17.825 9.61666 17.875 9.74999 17.875C9.81666 17.875 9.87916 17.8625 9.93749 17.8375C9.99582 17.8125 10.05 17.775 10.1 17.725L13.5 14.35L14.9 15.75L11.5 19.15C11.45 19.2 11.4125 19.2542 11.3875 19.3125C11.3625 19.3708 11.35 19.4333 11.35 19.5C11.35 19.6333 11.4042 19.75 11.5125 19.85C11.6208 19.95 11.7417 20 11.875 20ZM11.85 22C11.2333 22 10.6875 21.7958 10.2125 21.3875C9.73749 20.9792 9.45832 20.4667 9.37499 19.85C8.80832 19.7667 8.33332 19.5333 7.94999 19.15C7.56666 18.7667 7.33332 18.2917 7.24999 17.725C6.68332 17.6417 6.21249 17.4042 5.83749 17.0125C5.46249 16.6208 5.23332 16.15 5.14999 15.6C4.51666 15.5167 3.99999 15.2417 3.59999 14.775C3.19999 14.3083 2.99999 13.7583 2.99999 13.125C2.99999 12.7917 3.06249 12.4708 3.18749 12.1625C3.31249 11.8542 3.49166 11.5833 3.72499 11.35L9.52499 5.575L12.8 8.85C12.8333 8.9 12.8833 8.9375 12.95 8.9625C13.0167 8.9875 13.0833 9 13.15 9C13.3 9 13.425 8.95417 13.525 8.8625C13.625 8.77083 13.675 8.65 13.675 8.5C13.675 8.43333 13.6625 8.36667 13.6375 8.3C13.6125 8.23333 13.575 8.18333 13.525 8.15L9.94999 4.575C9.76666 4.375 9.55416 4.22917 9.31249 4.1375C9.07082 4.04583 8.81666 4 8.54999 4C8.29999 4 8.04999 4.04583 7.79999 4.1375C7.54999 4.22917 7.32499 4.375 7.12499 4.575L3.59999 8.125C3.44999 8.275 3.32499 8.45 3.22499 8.65C3.12499 8.85 3.05832 9.05 3.02499 9.25C2.99166 9.45 2.99166 9.65417 3.02499 9.8625C3.05832 10.0708 3.12499 10.2667 3.22499 10.45L1.77499 11.9C1.49166 11.5167 1.28332 11.0958 1.14999 10.6375C1.01666 10.1792 0.966657 9.71667 0.99999 9.25C1.03332 8.78333 1.14999 8.32917 1.34999 7.8875C1.54999 7.44583 1.82499 7.05 2.17499 6.7L5.69999 3.175C6.09999 2.79167 6.54582 2.5 7.03749 2.3C7.52916 2.1 8.03332 2 8.54999 2C9.06666 2 9.57082 2.1 10.0625 2.3C10.5542 2.5 10.9917 2.79167 11.375 3.175L11.65 3.45L11.925 3.175C12.325 2.79167 12.7708 2.5 13.2625 2.3C13.7542 2.1 14.2583 2 14.775 2C15.2917 2 15.7958 2.1 16.2875 2.3C16.7792 2.5 17.2167 2.79167 17.6 3.175L21.825 7.4C22.2083 7.78333 22.5 8.225 22.7 8.725C22.9 9.225 23 9.73333 23 10.25C23 10.7667 22.9 11.2708 22.7 11.7625C22.5 12.2542 22.2083 12.6917 21.825 13.075L13.625 21.25C13.3917 21.4833 13.1208 21.6667 12.8125 21.8C12.5042 21.9333 12.1833 22 11.85 22Z" fill="black" />
                                                            </svg>
                                                            {authBroker?.payload?.user?.config?.partner_menu_text !== undefined && !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)?
                                                               authBroker?.payload?.user?.config?.partner_menu_text:
                                                               "Learning Partners"} 
                                                        </a>
                                                    </li>
                                                    {showHeaderMenu.subscription ?
                                                        <li id="idPartnerMenu" className={`nav-item item-underline navbar_custom 
                                                    ${activeMenu === 'subscriptions' ? 'active' : ''}`}>
                                                            <a
                                                                className="nav-link"
                                                                onClick={() => {
                                                                    clickStreamUser("xsel-coaching-menu-clicked", {
                                                                        userId: auth.authBroker?.payload?.user.user_id,
                                                                    });
                                                                    navigate("/subscription");
                                                                }}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M8.85 17.825L12 15.925L15.15 17.85L14.325 14.25L17.1 11.85L13.45 11.525L12 8.125L10.55 11.5L6.9 11.825L9.675 14.25L8.85 17.825ZM5.825 22L7.45 14.975L2 10.25L9.2 9.625L12 3L14.8 9.625L22 10.25L16.55 14.975L18.175 22L12 18.275L5.825 22Z" fill="black" />
                                                                </svg>
                                                                Subscriptions
                                                            </a>
                                                        </li> : ""}
                                                    {/* <NavDropdown show={showMoreMenu} id="idMoreMenu" title=" More"
                                                        onClick={() => {
                                                            dispatch(setShowMoreMenuReq(!showMoreMenu))
                                                            setShowCertMenu(false)
                                                        }}>
                                                        {moreMenu.map((menu, index) => {
                                                            // console.log(menu.value, userRole, isGuest)
                                                            if (menu.value === 'report' && userRole === 'manager') {
                                                                return (
                                                                    <NavDropdown.Item
                                                                        id={`id${menu.value}Web`}
                                                                        onClick={() => goToMoreMenu(menu.value)}
                                                                        className="dropdownItem_getCertified customHover"
                                                                        key={`menu-${index + 1}`}
                                                                    >
                                                                        {menu.label}
                                                                    </NavDropdown.Item>
                                                                );
                                                            } else if (menu.value !== 'report') {
                                                                if (isGuest && menu.value !== 'role-request') {
                                                                    return (
                                                                        <NavDropdown.Item
                                                                            id={`id${menu.value}Web`}
                                                                            onClick={() => goToMoreMenu(menu.value)}
                                                                            className="dropdownItem_getCertified customHover"
                                                                            key={`menu-${index + 1}`}
                                                                        >
                                                                            {menu.label}
                                                                        </NavDropdown.Item>
                                                                    );
                                                                } else if (!isGuest) {
                                                                    return (
                                                                        <NavDropdown.Item
                                                                            id={`id${menu.value}Web`}
                                                                            onClick={() => goToMoreMenu(menu.value)}
                                                                            className="dropdownItem_getCertified customHover"
                                                                            key={`menu-${index + 1}`}
                                                                        >
                                                                            {menu.label}
                                                                        </NavDropdown.Item>
                                                                    );
                                                                }
                                                            }
                                                        })}
                                                    </NavDropdown> */}
                                                </>
                                            ) : (
                                                ""
                                            )}
                                            <li id="idLiveBtnMenu" className="nav-item dropdown streamlive livestrembtn">
                                                <a
                                                    className="nav-link dropdown-toggle d-flex gap-2 align-items-center"
                                                    role="button"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    {/* <LiveButtonComponent /> */}
                                                    <LiveMenuComponent />
                                                </a>

                                            </li>

                                        </ul>

                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                            {showAllMenu ? (
                                <>
                                    <div className="top-bar">
                                        <ul className="icons-bar">

                                            <>
                                                {/* SEARCH BAR */}
                                                <li className="nav-item search-tab">
                                                    <form className="d-flex navbar_custom">
                                                        {userRole === "instructor" || userRole === "host" ? (
                                                            ""
                                                        ) : (
                                                            <button
                                                                id="idSearchMenu"
                                                                className="btn searchBtn"
                                                                type="button"
                                                                onClick={() => {
                                                                    navigate("/search");
                                                                    clickStreamUser("global-search-button-clicked", {
                                                                        userId: authBroker?.payload?.user.user_id,
                                                                    });
                                                                }}
                                                                title="Search"
                                                                data-title="Search"
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                                    <path d="M6.5 13C4.68333 13 3.14583 12.3708 1.8875 11.1125C0.629167 9.85417 0 8.31667 0 6.5C0 4.68333 0.629167 3.14583 1.8875 1.8875C3.14583 0.629167 4.68333 0 6.5 0C8.31667 0 9.85417 0.629167 11.1125 1.8875C12.3708 3.14583 13 4.68333 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L17.3 15.9C17.4833 16.0833 17.575 16.3167 17.575 16.6C17.575 16.8833 17.4833 17.1167 17.3 17.3C17.1167 17.4833 16.8833 17.575 16.6 17.575C16.3167 17.575 16.0833 17.4833 15.9 17.3L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13ZM6.5 11C7.75 11 8.8125 10.5625 9.6875 9.6875C10.5625 8.8125 11 7.75 11 6.5C11 5.25 10.5625 4.1875 9.6875 3.3125C8.8125 2.4375 7.75 2 6.5 2C5.25 2 4.1875 2.4375 3.3125 3.3125C2.4375 4.1875 2 5.25 2 6.5C2 7.75 2.4375 8.8125 3.3125 9.6875C4.1875 10.5625 5.25 11 6.5 11Z" fill="black" />
                                                                </svg>
                                                            </button>
                                                        )}
                                                    </form>
                                                </li>

                                              {userRole!=="instructor" && userRole!=="host" &&  <li className="nav-item">
                                                    <div id="idCartMenu" className='cursor-pointer cart-item-reports' onClick={() => {
                                                        if (!window.location.pathname.includes('/cart')) {
                                                            navigateToDetails()
                                                        }
                                                        // setTimeout(() => { dispatch(setShowDropDown(false)) }, 100)
                                                    }} title="cart" data-title="cart">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                            <path d="M7 22.0898C6.45 22.0898 5.97917 21.894 5.5875 21.5023C5.19583 21.1107 5 20.6398 5 20.0898C5 19.5398 5.19583 19.069 5.5875 18.6773C5.97917 18.2857 6.45 18.0898 7 18.0898C7.55 18.0898 8.02083 18.2857 8.4125 18.6773C8.80417 19.069 9 19.5398 9 20.0898C9 20.6398 8.80417 21.1107 8.4125 21.5023C8.02083 21.894 7.55 22.0898 7 22.0898ZM17 22.0898C16.45 22.0898 15.9792 21.894 15.5875 21.5023C15.1958 21.1107 15 20.6398 15 20.0898C15 19.5398 15.1958 19.069 15.5875 18.6773C15.9792 18.2857 16.45 18.0898 17 18.0898C17.55 18.0898 18.0208 18.2857 18.4125 18.6773C18.8042 19.069 19 19.5398 19 20.0898C19 20.6398 18.8042 21.1107 18.4125 21.5023C18.0208 21.894 17.55 22.0898 17 22.0898ZM6.15 6.08984L8.55 11.0898H15.55L18.3 6.08984H6.15ZM5.2 4.08984H19.95C20.3333 4.08984 20.625 4.26068 20.825 4.60234C21.025 4.94401 21.0333 5.28984 20.85 5.63984L17.3 12.0398C17.1167 12.3732 16.8708 12.6315 16.5625 12.8148C16.2542 12.9982 15.9167 13.0898 15.55 13.0898H8.1L7 15.0898H19V17.0898H7C6.25 17.0898 5.68333 16.7607 5.3 16.1023C4.91667 15.444 4.9 14.7898 5.25 14.1398L6.6 11.6898L3 4.08984H1V2.08984H4.25L5.2 4.08984Z" fill="black" />
                                                        </svg>
                                                        {/* <img width={32} height={32} src='/images/cart_blank.png' /> */}
                                                        {(cartCount == 0 && isCartLoading) &&
                                                            <p className="cart-text cart-loading"><Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                                variant="light"
                                                            /></p>}
                                                        {cartCount === 0 ? "" : <p className='cart-text' >{cartCount === 0 ? "" : (cartCount < 10 ? '0' : '') + cartCount}</p>}
                                                    </div>
                                                    {/* {!(window.location.pathname.includes('/cart')) ?
                                                    : ""} */}
                                                </li> }

                                                {isLoggedIn ?
                                                    <>
                                                        {/* CALENDAR ICON */}
                                                        <li id="idCalendarMenu" className="nav-item navbar_custom">
                                                            <a
                                                                className="nav-link position-relative p-0"
                                                                role="button"
                                                                data-bs-toggle="dropdown"
                                                                href="#"
                                                                title="Calendar"
                                                                data-title="Calendar"
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="21" onClick={() => {
                                                                    navigate("/events-calendar");
                                                                    clickStreamUser("calendar-events-button-clicked", {
                                                                        userId: authBroker?.payload?.user.user_id,
                                                                    });
                                                                }
                                                                } viewBox="0 0 18 21" fill="none">
                                                                    <path d="M2 20.0898C1.45 20.0898 0.979167 19.894 0.5875 19.5023C0.195833 19.1107 0 18.6398 0 18.0898V4.08984C0 3.53984 0.195833 3.06901 0.5875 2.67734C0.979167 2.28568 1.45 2.08984 2 2.08984H3V1.08984C3 0.80651 3.09583 0.56901 3.2875 0.377344C3.47917 0.185677 3.71667 0.0898438 4 0.0898438C4.28333 0.0898438 4.52083 0.185677 4.7125 0.377344C4.90417 0.56901 5 0.80651 5 1.08984V2.08984H13V1.08984C13 0.80651 13.0958 0.56901 13.2875 0.377344C13.4792 0.185677 13.7167 0.0898438 14 0.0898438C14.2833 0.0898438 14.5208 0.185677 14.7125 0.377344C14.9042 0.56901 15 0.80651 15 1.08984V2.08984H16C16.55 2.08984 17.0208 2.28568 17.4125 2.67734C17.8042 3.06901 18 3.53984 18 4.08984V18.0898C18 18.6398 17.8042 19.1107 17.4125 19.5023C17.0208 19.894 16.55 20.0898 16 20.0898H2ZM2 18.0898H16V8.08984H2V18.0898ZM2 6.08984H16V4.08984H2V6.08984ZM9 12.0898C8.71667 12.0898 8.47917 11.994 8.2875 11.8023C8.09583 11.6107 8 11.3732 8 11.0898C8 10.8065 8.09583 10.569 8.2875 10.3773C8.47917 10.1857 8.71667 10.0898 9 10.0898C9.28333 10.0898 9.52083 10.1857 9.7125 10.3773C9.90417 10.569 10 10.8065 10 11.0898C10 11.3732 9.90417 11.6107 9.7125 11.8023C9.52083 11.994 9.28333 12.0898 9 12.0898ZM5 12.0898C4.71667 12.0898 4.47917 11.994 4.2875 11.8023C4.09583 11.6107 4 11.3732 4 11.0898C4 10.8065 4.09583 10.569 4.2875 10.3773C4.47917 10.1857 4.71667 10.0898 5 10.0898C5.28333 10.0898 5.52083 10.1857 5.7125 10.3773C5.90417 10.569 6 10.8065 6 11.0898C6 11.3732 5.90417 11.6107 5.7125 11.8023C5.52083 11.994 5.28333 12.0898 5 12.0898ZM13 12.0898C12.7167 12.0898 12.4792 11.994 12.2875 11.8023C12.0958 11.6107 12 11.3732 12 11.0898C12 10.8065 12.0958 10.569 12.2875 10.3773C12.4792 10.1857 12.7167 10.0898 13 10.0898C13.2833 10.0898 13.5208 10.1857 13.7125 10.3773C13.9042 10.569 14 10.8065 14 11.0898C14 11.3732 13.9042 11.6107 13.7125 11.8023C13.5208 11.994 13.2833 12.0898 13 12.0898ZM9 16.0898C8.71667 16.0898 8.47917 15.994 8.2875 15.8023C8.09583 15.6107 8 15.3732 8 15.0898C8 14.8065 8.09583 14.569 8.2875 14.3773C8.47917 14.1857 8.71667 14.0898 9 14.0898C9.28333 14.0898 9.52083 14.1857 9.7125 14.3773C9.90417 14.569 10 14.8065 10 15.0898C10 15.3732 9.90417 15.6107 9.7125 15.8023C9.52083 15.994 9.28333 16.0898 9 16.0898ZM5 16.0898C4.71667 16.0898 4.47917 15.994 4.2875 15.8023C4.09583 15.6107 4 15.3732 4 15.0898C4 14.8065 4.09583 14.569 4.2875 14.3773C4.47917 14.1857 4.71667 14.0898 5 14.0898C5.28333 14.0898 5.52083 14.1857 5.7125 14.3773C5.90417 14.569 6 14.8065 6 15.0898C6 15.3732 5.90417 15.6107 5.7125 15.8023C5.52083 15.994 5.28333 16.0898 5 16.0898ZM13 16.0898C12.7167 16.0898 12.4792 15.994 12.2875 15.8023C12.0958 15.6107 12 15.3732 12 15.0898C12 14.8065 12.0958 14.569 12.2875 14.3773C12.4792 14.1857 12.7167 14.0898 13 14.0898C13.2833 14.0898 13.5208 14.1857 13.7125 14.3773C13.9042 14.569 14 14.8065 14 15.0898C14 15.3732 13.9042 15.6107 13.7125 15.8023C13.5208 15.994 13.2833 16.0898 13 16.0898Z" fill="black" />
                                                                </svg>



                                                                {userRole != "realtor" && sessionCount > 0 ? (
                                                                    <span className="session-badge">{sessionCount}</span>
                                                                ) : (
                                                                    ""
                                                                )}
                                                                {false && <span className="calicount"></span>}
                                                            </a>
                                                        </li>
                                                        {/* NOTIFICATION ICON */}
                                                       { userRole != "host" && userRole != "instructor" && <div id="idNotificationMenu">
                                                            <Notification />
                                                        </div>}
                                                    </>
                                                    : ""
                                                }


                                            </>
                                            {/* {userRole != "host" && userRole != "instructor" ? (
                ) : (
                    ""
                )} */}
                                        </ul>

                                        {isLoggedIn && <ul
                                            className={
                                                userRole === "instructor" ||
                                                    userRole === "host" ||
                                                    userRole === "manager"
                                                    ? "navbar-nav profile_thumbImg host_inst_login"
                                                    : (userRole === "realtor" || userRole === "customer")
                                                        ? "navbar-nav profile_thumbImg realtor_manager_login"
                                                        : "navbar-nav profile_thumbImg"
                                            }
                                        >
                                            <li className="nav-item d-flex gap-1 align-items-center pf-desk">
                                                {false && <span className="wlcmtxt" title={name}>Welcome <span className="nameusershow">{name}</span></span>}
                                                <ProfileMenuSection from={"Web"} signOut={signOut} renderLoginSignup={renderLoginSignup}/>
                                            </li>
                                        </ul>}
                                    </div>
                                    {!isLoggedIn &&
                                        renderLoginSignup()
                                    }
                                </>
                            ) : (
                                ""
                            )}
                        </div>

                    </div>
                </div>
            </nav>

            { renderCard()  /*!(window.location.pathname.includes('/home')) &&*/} 

            <ToastContainer
          className="b2c-taost  p-3 position-fixed"
          position={"bottom-end"}
          style={{ zIndex: 1002 }}
        >
          <Toast show={toastShow} delay={3000} autohide onClose={()=>setToastShow(false)}>
            <Toast.Body>{message}</Toast.Body>
          </Toast>
        </ToastContainer>

        </>
    );
};

export default HeaderNewMenu;
